import { render, staticRenderFns } from "./CompletedProcedures.vue?vue&type=template&id=eb545124&"
import script from "./CompletedProcedures.vue?vue&type=script&lang=js&"
export * from "./CompletedProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports